<template>
    <div class="member-profile-main">
        <ValidationObserver ref="form">
            <form>
                <div class="profile-details">
                    <div class="flex colx2 wrap">
                        <Input
                            label="Name of the Profile"
                            labelClass="label-member-profile"
                            inputClass="profile-name-input"
                            type="text"
                            class="field-container"
                            placeholder="Enter name of the profile"
                            name="Name of the Profile"
                            v-model="memberProfileSetting.profileName"
                            required
                        />
                    </div>
                    <div class="mt-4">
                        <label class="label-member-profile">Choose Profile theme*</label>
                        <div class="d-flex mb-3">
                            <label role="button" for="child" class="profile-theme-card d-flex align-items-center me-3 p-3" :class="(memberProfileSetting.ageGroup === 'child') ? 'checked': ''">
                                <div class="section-img">
                                <svg id="Capa_1" enable-background="new 0 0 512 512" height="60" viewBox="0 0 512 512" width="60" xmlns="http://www.w3.org/2000/svg"><g><path d="m368.852 299.953c13.57 0 24.609-11.04 24.609-24.609 0-4.143-3.358-7.5-7.5-7.5s-7.5 3.357-7.5 7.5c0 5.299-4.311 9.609-9.609 9.609s-9.609-4.311-9.609-9.609c0-4.143-3.358-7.5-7.5-7.5s-7.5 3.357-7.5 7.5c-.001 13.569 11.039 24.609 24.609 24.609z"/><path d="m408.175 257.883c4.142 0 7.5-3.357 7.5-7.5v-7.837c3.703-.459 6.57-3.616 6.57-7.443 0-4.143-3.358-7.5-7.5-7.5h-6.57c-4.142 0-7.5 3.357-7.5 7.5v15.28c0 4.143 3.358 7.5 7.5 7.5z"/><path d="m322.028 242.547v7.837c0 4.143 3.358 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-15.28c0-4.143-3.358-7.5-7.5-7.5h-6.57c-4.142 0-7.5 3.357-7.5 7.5 0 3.826 2.867 6.984 6.57 7.443z"/><path d="m480.945 251.731c2.129-4.505 3.326-9.533 3.326-14.837 0-8.827-3.305-16.893-8.734-23.041.862-1.221 1.372-2.707 1.372-4.316 0-22.152 1.106-35.289-5.558-54.343-1.368-3.91-5.646-5.975-9.556-4.604-3.91 1.367-5.971 5.646-4.604 9.556 5.447 15.571 4.717 26.372 4.717 41.891-9.566 0-35.337 0-46.202 0-21.7 0-39.355-17.654-39.356-39.354 0-4.143-3.358-7.5-7.5-7.5s-7.5 3.357-7.5 7.5c0 21.7-17.655 39.354-39.356 39.354h-32.588-13.614v-13.972c0-46.61 37.92-84.53 84.53-84.53.567 0 1.028.461 1.028 1.028 0 4.142 3.358 7.499 7.5 7.499s7.5-3.357 7.5-7.499c0-.567.461-1.028 1.028-1.028 24.435.001 47.666 10.573 63.738 29.005 2.722 3.123 7.46 3.445 10.582.725 3.122-2.723 3.446-7.46.724-10.582-18.921-21.7-46.273-34.146-75.043-34.147-3.132 0-6.057.903-8.528 2.462-2.471-1.559-5.396-2.462-8.528-2.462-54.881 0-99.53 44.649-99.53 99.53v21.472c0 1.608.511 3.095 1.372 4.316-2.518 2.851-4.58 6.112-6.064 9.674-.901-11.06-6.481-20.773-14.812-27.127v-28.573c0-56.256-45.767-102.023-102.023-102.023-13.968 0-8.371-.241-27.691 1.269-26.65 2.08-50.499 16.341-64.936 38.527l-22.586-7.219c-4.68-1.5-9.539 1.854-9.775 6.786-.107 2.26-2.37 52.486 6.788 87.469-12.477 6.258-21.066 19.167-21.066 34.052 0 19.314 14.456 35.316 33.117 37.754 4.697 20.152 15.793 38.445 31.666 52.012 4.162 3.557 8.603 6.723 13.253 9.505h-15.782c-25.931 0-47.027 21.097-47.027 47.027v65.723c0 4.143 3.358 7.5 7.5 7.5h12.459c4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5h-4.959v-58.223c0-17.66 14.367-32.027 32.027-32.027h21.818c3.727 22.114 23.727 38.741 47.092 37.233 21.151-1.363 37.909-17.277 41.276-37.233h21.821c17.66 0 32.028 14.367 32.028 32.027v58.223h-156.102c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h163.603c4.142 0 7.5-3.357 7.5-7.5v-65.723c0-6.245-1.234-12.205-3.454-17.662h12.05c7.545 0 14.741-1.507 21.318-4.221-4.627 7.155-7.325 15.669-7.325 24.805v62.801c0 4.143 3.358 7.5 7.5 7.5h195.45c4.142 0 7.5-3.357 7.5-7.5v-62.801c0-9.023-2.632-17.439-7.154-24.539 6.394 2.542 13.355 3.955 20.645 3.955h16.68c4.142 0 7.5-3.357 7.5-7.5v-45.934c0-21.366-12.383-40.792-31.055-50.16zm-158.949-34.693c19.934 0 37.396-10.784 46.856-26.827 9.461 16.043 26.922 26.827 46.856 26.827h33.707c10.949 0 19.856 8.907 19.856 19.856 0 5.354-2.139 10.21-5.595 13.784-3.949 4.08-9.425 6.279-15.057 6.05-3.793-.175-7.09 2.522-7.714 6.256-5.706 34.113-35.216 60.916-72.053 60.916-26.026 0-50.337-13.759-63.418-36.641-.122-.309-.262-.612-.425-.904-3.054-5.478-5.37-11.265-6.916-17.269-.031-.12-.056-.242-.086-.362-.426-1.692-.831-3.487-1.208-5.741-.623-3.725-3.934-6.428-7.714-6.256-11.224.456-20.652-8.599-20.652-19.835 0-10.949 8.908-19.856 19.856-19.856.273 0 .545.012.816.022.32.013.635.005.947-.022h31.944zm46.979 153.411c-14.27 0-25.88-11.61-25.88-25.881v-6.982-2.521c8.512 2.612 17.401 3.837 25.756 3.837 8.629 0 17.615-1.31 26.003-3.912v9.579c0 13.825-10.896 25.153-24.55 25.847-.44.022-.883.033-1.329.033zm-59.283-40.363c-.002 0-.006 0-.009 0-5.141.002-10.081.868-14.698 2.438 4.635-6.266 7.992-13.528 9.696-21.401 2.2 2.343 4.526 4.582 6.988 6.686 5.069 4.332 10.586 8.038 16.426 11.086v1.191zm100.163-1.314c8.49-4.465 16.258-10.29 23.167-17.648 1.684 7.779 4.985 14.96 9.536 21.175-8.563-2.766-13.031-2.213-32.702-2.213v-1.314zm-380.839-213.057 18.709 5.979c3.409 1.087 7.115-.382 8.847-3.516 11.491-20.788 32.49-34.303 56.171-36.15 18.855-1.472 13.138-1.224 26.523-1.224 47.984 0 87.023 39.038 87.023 87.023v21.665c-6.554-1.411-4.481-.849-107.341-.849-7.478 0-14.641-1.662-21.095-4.663-14.199-6.602-24.967-19.685-28.121-35.807-1.205-6.16-8.787-8.013-12.837-3.684-10.819 11.566-18.383 25.267-22.49 39.486-5.157-23.328-5.574-53.097-5.389-68.26zm17.701 140.281c-.607-3.627-3.746-6.263-7.394-6.263-.101 0-.203.002-.305.006-.313.013-.626.025-.942.025-12.724 0-23.076-10.351-23.076-23.075 0-12.51 9.972-22.622 22.238-23.055.03-.001.061-.001.091-.002.558-.017 1.116-.017 1.671.006.012 0 .024 0 .036.001.023.001.046-.002.069-.001 3.741.116 6.993-2.557 7.612-6.256 1.693-10.123 5.248-19.753 10.462-28.483.745-1.247 1.524-2.476 2.336-3.685 10.324 22.929 33.407 38.43 59.433 38.43h100.295.005c3.641.168 7.433 1.267 10.702 3.214.058.035.12.058.179.091 6.682 4.041 11.11 11.361 11.11 19.739 0 12.724-10.352 23.075-23.076 23.075-.316 0-.63-.013-.943-.025-3.773-.135-7.075 2.53-7.699 6.257-6.797 40.644-41.771 68.821-81.402 68.821-39.936.001-74.653-28.466-81.402-68.82zm80.036 107.263c-14.676-.734-26.642-12.15-28.144-26.708-.011-.109-.017-.22-.027-.33-.03-.324-.055-.65-.074-.977 9.877 3.152 20.176 4.572 29.613 4.572 9.615 0 19.997-1.47 29.898-4.665-.907 16.334-14.91 28.925-31.266 28.108zm67.509-37.299h-16.057c4.65-2.782 9.091-5.948 13.253-9.505 15.872-13.566 26.969-31.859 31.665-52.012 13.941-1.821 25.533-11.214 30.505-23.902.414 3.964 1.495 7.732 3.129 11.19-18.672 9.368-31.055 28.793-31.055 50.16v36.159c-8.336-7.51-19.362-12.09-31.44-12.09zm46.441 14.365v-38.434c0-16.689 10.31-31.77 25.523-38.015 4.982 4.068 10.981 6.624 16.979 7.505 1.732 7.235 4.459 14.302 7.752 20.531v7.338c0 22.648-18.425 41.074-41.073 41.074h-9.181zm218.625 90.885h-180.45v-55.301c0-16.996 13.828-30.823 30.824-30.823h18.397c.276 22.147 18.382 40.363 40.876 40.363 22.237 0 40.596-17.936 40.877-40.363h18.652c16.996 0 30.823 13.827 30.823 30.823v55.301zm37.672-90.885h-9.182c-22.648 0-41.073-18.426-41.073-41.074v-7.338c3.342-6.322 6.042-13.388 7.752-20.531 5.635-.827 11.317-3.117 16.259-6.956.239-.185.486-.357.72-.548 15.214 6.244 25.524 21.324 25.524 38.013z"/><path d="m128.12 296.416c14.68 0 26.623-11.943 26.623-26.623 0-4.143-3.358-7.5-7.5-7.5s-7.5 3.357-7.5 7.5c0 6.409-5.214 11.623-11.623 11.623s-11.624-5.214-11.624-11.623c0-4.143-3.358-7.5-7.5-7.5s-7.5 3.357-7.5 7.5c.001 14.679 11.944 26.623 26.624 26.623z"/><path d="m84.168 217.564c-4.142 0-7.5 3.357-7.5 7.5v16.582c0 4.143 3.358 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-16.582c0-4.142-3.358-7.5-7.5-7.5z"/><path d="m172.072 249.146c4.142 0 7.5-3.357 7.5-7.5v-16.582c0-4.143-3.358-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v16.582c0 4.143 3.358 7.5 7.5 7.5z"/></g></svg>
                                </div>
                                <div class="d-flex flex-column ms-4">
                                    <span class="profile-theme-card-label mb-1">Child</span>
                                    <input
                                        value="child"
                                        id="child"
                                        type="radio"
                                        name="child"
                                        v-model="memberProfileSetting.ageGroup"
                                        :checked="memberProfileSetting.ageGroup == 'child'"
                                        @input="$emit('input', 'child')"
                                    />
                                </div>
                            </label>
                            <label role="button" for="adult" class="profile-theme-card d-flex align-items-center me-3 p-3" :class="(memberProfileSetting.ageGroup === 'adult') ? 'checked': ''">
                                <div class="section-img img-adult">
                                    <svg
                                    version="1.1"
                                    id="svg2655"
                                    xml:space="preserve"
                                    width="60"
                                    height="60"
                                    viewBox="0 0 682.66669 682.66669"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:svg="http://www.w3.org/2000/svg"><defs
                                        id="defs2659"><clipPath
                                        clipPathUnits="userSpaceOnUse"
                                        id="clipPath2669"><path
                                            d="M 0,512 H 512 V 0 H 0 Z"
                                            id="path2667" /></clipPath></defs><g
                                        id="g2661"
                                        transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
                                        id="g2663"><g
                                            id="g2665"
                                            clip-path="url(#clipPath2669)"><g
                                            id="g2671"
                                            transform="translate(95.6772,207.9033)"><path
                                                d="m 0,0 v -23.181 c 0,-6.901 -4.416,-13.027 -10.962,-15.21 L -49.809,-51.34 c -22.913,-7.638 -38.368,-29.08 -38.368,-53.233 v -15.669"
                                                style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                                                id="path2673" /></g><g
                                            id="g2675"
                                            transform="translate(247.9839,87.6611)"><path
                                                d="m 0,0 v 15.669 c 0,24.153 -15.455,45.596 -38.368,53.233 l -38.847,12.95 c -6.547,2.182 -10.962,8.308 -10.962,15.209 v 23.181"
                                                style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                                                id="path2677" /></g><g
                                            id="g2679"
                                            transform="translate(187.209,159.8052)"><path
                                                d="m 0,0 c -19.386,-32.063 -59.467,-56.112 -59.467,-56.112 0,0 -40.081,24.049 -59.463,56.102"
                                                style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                                                id="path2681" /></g><g
                                            id="g2683"
                                            transform="translate(191.8711,288.0645)"><path
                                                d="m 0,0 v -24.048 c 0,-35.418 -28.711,-64.129 -64.129,-64.129 v 0 c -35.418,0 -64.129,28.711 -64.129,64.129 v 22.356 c 0,6.33 1.874,12.519 5.385,17.786 l 10.647,15.97"
                                                style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                                                id="path2685" /></g><g
                                            id="g2687"
                                            transform="translate(95.6772,344.1772)"><path
                                                d="M 0,0 C 0,0 96.194,-32.064 96.194,-56.113"
                                                style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                                                id="path2689" /></g><g
                                            id="g2691"
                                            transform="translate(159.8066,191.8711)"><path
                                                d="m 0,0 h 64.129 v 120.242 c 0,53.126 -43.067,96.194 -96.193,96.194 h -10e-4 c -53.126,0 -96.193,-43.068 -96.193,-96.194 V 0 h 64.129"
                                                style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                                                id="path2693" /></g><g
                                            id="g2695"
                                            transform="translate(99.6855,288.0645)"><path
                                                d="M 0,0 V -8.016"
                                                style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                                                id="path2697" /></g><g
                                            id="g2699"
                                            transform="translate(155.7983,288.0645)"><path
                                                d="M 0,0 V -8.016"
                                                style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                                                id="path2701" /></g><g
                                            id="g2703"
                                            transform="translate(111.7095,243.2241)"><path
                                                d="m 0,0 c 4.492,-2.019 10.002,-3.256 16.032,-3.256 6.031,0 11.541,1.237 16.033,3.256"
                                                style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                                                id="path2705" /></g><g
                                            id="g2707"
                                            transform="translate(344.1772,251.2402)"><path
                                                d="m 0,0 c 4.492,-2.019 10.002,-3.256 16.032,-3.256 6.03,0 11.541,1.237 16.032,3.256"
                                                style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                                                id="path2709" /></g><g
                                            id="g2711"
                                            transform="translate(504.5,87.6611)"><path
                                                d="m 0,0 v 15.669 c 0,24.153 -15.455,45.596 -38.368,53.233 l -46.863,15.621 c -6.547,2.183 -10.962,8.309 -10.962,15.21 v 28.525"
                                                style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                                                id="path2713" /></g><g
                                            id="g2715"
                                            transform="translate(312.1128,215.9194)"><path
                                                d="m 0,0 v -28.525 c 0,-6.901 -4.416,-13.028 -10.962,-15.21 L -52.51,-57.584"
                                                style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                                                id="path2717" /></g><g
                                            id="g2719"
                                            transform="translate(288.0645,296.0806)"><path
                                                d="m 0,0 v -24.048 c 0,-39.845 32.3,-72.145 72.145,-72.145 h 0.001 c 39.844,0 72.145,32.3 72.145,72.145 v 48.096 c 0,0 0,32.065 -48.097,32.065 h -60.59 c -6.901,0 -13.027,-4.416 -15.209,-10.963 L 16.032,32.064"
                                                style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                                                id="path2721" /></g><g
                                            id="g2723"
                                            transform="translate(431.0366,166.8608)"><path
                                                d="m 0,0 c -17.581,-19.121 -42.805,-31.103 -70.827,-31.103 -28.483,0 -54.074,12.379 -71.687,32.051"
                                                style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                                                id="path2725" /></g><g
                                            id="g2727"
                                            transform="translate(328.145,296.0806)"><path
                                                d="M 0,0 V -8.016"
                                                style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                                                id="path2729" /></g><g
                                            id="g2731"
                                            transform="translate(392.2744,296.0806)"><path
                                                d="M 0,0 V -8.016"
                                                style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                                                id="path2733" /></g><g
                                            id="g2735"
                                            transform="translate(288.0645,296.0806)"><path
                                                d="m 0,0 c 0,0 -24.048,24.048 -24.048,56.113 0,24.048 16.032,40.081 32.137,43.608"
                                                style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                                                id="path2737" /></g><g
                                            id="g2739"
                                            transform="translate(295.5649,374.5249)"><path
                                                d="m 0,0 c 0,0 -7.5,49.814 72.661,49.814 65.467,0 87.806,-31.446 88.177,-64.129 0.402,-35.35 -24.048,-72.145 -24.048,-72.145"
                                                style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                                                id="path2741" /></g></g></g>
                                            </g>
                                    </svg>
                                </div>
                                <div class="d-flex flex-column ms-4">
                                    <span class="profile-theme-card-label mb-1">Adult</span>
                                    <input
                                        value="adult"
                                        id="adult"
                                        type="radio"
                                        name="adult"
                                        v-model="memberProfileSetting.ageGroup"
                                        :checked="memberProfileSetting.ageGroup == 'adult'"
                                        @input="$emit('input', 'adult')"
                                    />
                                </div>
                            </label>
                            <label role="button" for="older" class="profile-theme-card d-flex align-items-center me-3 p-3" :class="(memberProfileSetting.ageGroup === 'older') ? 'checked': ''">
                                <div class="section-img">
                                <svg id="Image" height="60" viewBox="0 0 64 64" width="60" xmlns="http://www.w3.org/2000/svg"><path d="m57.865 39.142c.276-.688.298-1.465.027-2.185l-3.479-8.94c-1.131-2.905-3.412-5.145-6.252-6.251 1.06-1.589.802-3.068.84-3.383.454-.821.314-3.013-.126-3.805-.254-.457-.622-.849-1.047-1.185.603-.989.721-2.057.312-3.044-.601-1.449-2.187-2.349-4.14-2.349s-3.539.9-4.139 2.348c-.409.987-.291 2.055.312 3.044-.426.336-.794.728-1.047 1.185-.44.792-.58 2.984-.126 3.805.038.316-.219 1.795.84 3.383-2.84 1.106-5.121 3.346-6.252 6.251l-1.66 4.258-1.864-6.818c-.928-3.394-3.309-6.112-6.472-7.486.261-.605.408-1.27.408-1.97v-2c0-.337-.045-.671-.114-1h1.114c1.324 0 1.323-2 0-2h-1.136c-.28-1.543-1.015-4-2.864-4-1.363 0-1.403.563-2 .563-.238 0-.273-.021-.439-.125-.357-.222-.771-.438-1.561-.438-1.849 0-2.584 2.457-2.864 4h-1.136c-1.324 0-1.323 2 0 2h1.114c-.069.329-.114.663-.114 1v2c0 .7.147 1.365.408 1.97-3.164 1.375-5.544 4.092-6.472 7.486l-3.384 12.383c-.182.705-.049 1.431.343 2.028-.551.544-.895 1.299-.895 2.133v14c0 1.323 2 1.324 2 0v-14c0-.551.448-1 1-1s1 .449 1 1c0 1.323 2 1.324 2 0 0-.692-.245-1.322-.64-1.83.566-.438 1.023-1.023 1.287-1.722l1.353-3.638v19.19c0 1.654 1.346 3 3 3h1c1.193 0 2.267-.525 3-1.357.733.832 1.807 1.357 3 1.357h1c1.654 0 3-1.346 3-3v-19.19l1.354 3.644c.576 1.523 2.048 2.546 3.666 2.546.276 0 .542-.061.799-.148.275.088.556.148.841.148 1.209 0 2.295-.672 2.872-1.84l1.39-3.596-2.904 15.249c-.117.614.354 1.187.982 1.187h3v2.5c0 1.378 1.121 2.5 2.5 2.5h.5c1.201 0 2.266-.542 3-1.382.734.84 1.799 1.382 3 1.382h.5c1.379 0 2.5-1.122 2.5-2.5v-2.5h3c.628 0 1.099-.572.982-1.187l-2.921-15.338 1.545 3.964c.343.684.934 1.171 1.627 1.404-.149.356-.233.747-.233 1.157 0 1.323 2 1.324 2 0 0-.551.448-1 1-1s1 .449 1 1v14c0 1.323 2 1.324 2 0v-14c0-1.352-.904-2.484-2.135-2.858zm-16.865-20.142v-.152c.875-.222 1.962-.696 2.794-1.472.113-.105.291-.106.406.001.83.777 1.921 1.251 2.8 1.472v.151c0 1.654-1.346 3-3 3s-3-1.346-3-3zm3-4.937c1.226 0 2.687.694 3.122 1.478.099.208.163.821.164 1.317-1.851-.564-1.808-1.559-3.29-1.559-1.461 0-1.404.965-3.282 1.557.001-.496.064-1.105.16-1.308.439-.792 1.9-1.485 3.126-1.485zm0-4.063c1.684 0 2.992 1.031 2.063 2.435-.702-.245-1.425-.373-2.063-.373s-1.361.127-2.063.373c-.929-1.404.38-2.435 2.063-2.435zm-27-1c.618 0 .75.563 2 .563 1.241 0 1.387-.553 1.963-.569.273.128.624.999.853 2.007h-5.632c.227-1.008.57-1.878.816-2.001zm4.803 4c.117.323.197.654.197 1v2c0 1.654-1.346 3-3 3s-3-1.346-3-3v-2c0-.346.08-.677.197-1zm1.197 42h-1c-1.103 0-2-.897-2-2v-10c0-1.323-2-1.324-2 0v10c0 1.103-.897 2-2 2h-1c-.552 0-1-.449-1-1v-14h10v14c0 .551-.448 1-1 1zm6.228-17.249-3.29-8.85c-.384-1.037-1.938-.764-1.938.349v8.75h-10v-8.75c0-1.107-1.55-1.393-1.938-.349l-3.288 8.845c-.544 1.442-2.553 1.622-2.29.607l3.381-12.37c.804-2.943 2.934-5.262 5.741-6.335.893.832 2.081 1.352 3.394 1.352s2.501-.52 3.394-1.351c2.806 1.073 4.937 3.392 5.741 6.335l3.378 12.357c.09.351-.156.659-.493.659-.791 0-1.511-.503-1.792-1.249zm11.772 17.249h-.5c-.275 0-.5-.224-.5-.5v-2.5h3v1c0 1.103-.897 2-2 2zm7-.5c0 .276-.225.5-.5.5h-.5c-1.103 0-2-.897-2-2v-1h3zm2.932-24.863c-.47-1.208-2.349-.523-1.863.726.606 1.558.604 2.964-.009 3.858-.442.649-1.202.883-1.825.716-1.281-.339-1.795 1.589-.52 1.932.84.225 1.699.174 2.53-.239l2.547 13.37h-15.584l2.547-13.37c.775.385 1.607.473 2.484.251 1.278-.325.792-2.262-.494-1.938-.619.159-1.365-.078-1.805-.722-.612-.894-.615-2.3-.009-3.858l.001-.003c.476-1.233-1.404-1.915-1.864-.723 0 .001 0 .001-.001.002v.001l-3.362 8.714c-.05.101-.118.191-.194.274.044-.807-.16-.964-.699-3.115l2.638-6.769c1.05-2.697 3.307-4.694 6.071-5.426.735.421 1.573.682 2.479.682.905 0 1.743-.26 2.476-.683 2.765.731 5.023 2.728 6.073 5.425l3.476 8.929c.423 1.127-1.146 1.803-1.593.956z"/></svg>
                                </div>
                                <div class="d-flex flex-column ms-4">
                                    <span class="profile-theme-card-label mb-1">Older</span>
                                    <input
                                        value="older"
                                        id="older"
                                        type="radio"
                                        name="older"
                                        v-model="memberProfileSetting.ageGroup"
                                        :checked="memberProfileSetting.ageGroup == 'older'"
                                        @input="$emit('input', 'older')"
                                    />
                                </div>
                            </label>
                        </div>
                    </div>
                    <div class="mt-5">
                        <label class="label-member-profile">Personalize Settings for tablet functions</label>
                        <div class="d-flex flex-wrap" style="gap: .5em;">
                            <ProfileFunctionCard v-for="coreFunction in coreFunctionList" :key="coreFunction.id" :profileFunction="coreFunction" @onToggle="onToggle($event)"/>
                        </div>
                    </div>
                </div>
            </form>
        </ValidationObserver>
        <hr />
        <div class="d-flex justify-content-between align-items-end">
            <div>
                <span class="app-launcher-label">3rd Party app launcher</span>
                <Toggle
                    id="app-launcher"
                    class="toggle-switch"
                    labelClass="switch"
                    v-model="openLauncherModal"
                    spanClass="slider"
                />
            </div>
            <div>
                <button v-if="showSaveSetting" type="button" class="primary btn-profile-save" @click="saveProfileSetting">Save setting</button>
                <div class="d-flex align-items-center" v-if="!showSaveSetting">
                    <button v-if="!showSaveSetting" type="button" class="primary btn-profile-save" @click="updateProfile">Update setting</button>
                    <button type="button" class="no-bg text-button btn-edit-cancel" @click="cancelEdit()">Cancel</button>
                </div>
            </div>
        </div>
        <div class="profile-listing mt-5">
            <div class="profile-listing-header">
                <span>Created Profile Build History</span>
            </div>
            <div class="profile-listing-body px-5 pb-2">
                <b-input-group class="w-25 mt-4 mb-2 ms-5">
                    <b-form-input
                        id="filter-input"
                        v-model="filter"
                        type="search"
                        placeholder="Search Profile Name..."
                        :title="filter ? 'Clear Search' : ''"
                    ></b-form-input>
                </b-input-group>
                <div v-if="filter && noSearchResultRows" class="message-filtered-rows"><span class="fw-bolder me-1">{{ noSearchResultRows }}</span><span>result(s) found</span></div>
                <b-table
                    :items="memberProfileHistoryList"
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="filter"
                    @filtered="onFiltered"
                    show-empty
                    empty-filtered-text="There are no records matching based on your search"
                    bordered
                    responsive
                >
                    <template #cell(action)="row">
                        <div class="d-flex justify-content-center align-items-center">
                            <ejs-tooltip
                                class="tooltipcontainer"
                                content="Edit"
                                target="#target"
                                cssClass="customtooltip"
                                position="BottomRight"
                            >
                                <span id="target" class="material-symbols-outlined icon-edit me-2" @click="editProfile(row)">
                                    edit_square
                                </span>
                            </ejs-tooltip>
                            <ejs-tooltip
                                class="tooltipcontainer"
                                content="Delete"
                                target="#target"
                                cssClass="customtooltip"
                                position="BottomRight"
                            >
                                <span id="target" class="material-symbols-outlined icon-delete" @click="deleteProfile(row)">
                                    delete
                                </span>
                            </ejs-tooltip>
                        </div>
                    </template>
                </b-table>
                <div class="b-table-pagination">
                    <div class="pagination-count-per-page">
                        <div class="pagination-number-per-page">
                            <div>
                                <span>Per page:</span>
                            </div>
                            <div>
                                <select style="" @change="changeCountPerPage">
                                    <option v-for="item in perPageOptions" :key="item" :value="item">
                                        {{ item }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <b-pagination align="right" v-model="currentPage" :total-rows="rows" :per-page="perPage"
                        aria-controls="my-table" first-text="First" prev-text="Prev" next-text="Next"
                        last-text="Last"></b-pagination>
                </div>
            </div>
        </div>
        <!-- ### Alert Warning Popup ##### -->
        <div class="profile-delete-modal">
            <AlertDeleteMemberProfile
                v-if="showDeleteAlert"
                :open="showDeleteAlert"
                :clientListUsingProfile="clientListUsingProfile" 
                @cancel="showDeleteAlert = false"
                @handleDelete="handleDelete"
                @handleMemberNameClick="onClickMemberName">
            </AlertDeleteMemberProfile>
        </div>
        <div class="third-party-app-delete-modal">
            <AlertDeleteThirdPartyApp
                v-if="showThirdPartyDeleteAlert"
                :open="showThirdPartyDeleteAlert"
                @cancel="showThirdPartyDeleteAlert = false;openLauncherModal = true"
                @handleDelete="handleThirdPartyDelete">
            </AlertDeleteThirdPartyApp>
        </div>
        <LauncherModal v-if="openLauncherModal" :open="openLauncherModal" @close="close" :coreFunctionList="coreFunctionList" @onSaveThirdPartyApplication="onSaveThirdPartyApplication" :showSaveSetting="showSaveSetting" @onDeleteThirdParty="onDeleteThirdParty"/>
        <Loading v-if="showLoader" />
    </div>
</template>
<script>
    import { ValidationObserver } from 'vee-validate';
    import ProfileFunctionCard from '../member-profiles/ProfileFunctionCard.vue';
    import LauncherModal from '../member-profiles/LauncherModal.vue';
    import { memberProfile } from '@/util/apiRequests';
    import Loading from '@/components/general/loading/loading.vue';
    import dayjs from '@/util/dayjs';
    import AlertDeleteMemberProfile from './DeleteMemberProfileAlert.vue';
    import AlertDeleteThirdPartyApp from './DeleteThirdPartyAlert.vue';

    export default {
        name: 'MemberProfiles',
        components: {
            ProfileFunctionCard, ValidationObserver, LauncherModal, Loading, AlertDeleteMemberProfile, AlertDeleteThirdPartyApp
        },
        data() {
            return {
                memberProfileSetting: {
                    profileName: '',
                    ageGroup: 'adult',
                    functionIds: []
                },
                coreFunctionList: [],
                memberProfileHistoryList: [],
                fields: [
                    { key: 'profile_name', label: 'Profile Name'},
                    { key: 'age_group', label: 'Profile Theme'},
                    { key: 'updated_at', label: 'Updated Date & Time'},
                    { key: 'created_at', label: 'Created Date & Time'},
                    { key: 'action', label: 'Action' }
                ],
                showSaveSetting: true,
                showLoader: false,
                openLauncherModal: false,
                selectedProfileRowId: null,
                showDeleteAlert: false,
                showThirdPartyDeleteAlert: false,
                memberProfileIdToDelete: null,
                thirdPartyFunctionIdToDelete: null,
                // noOfClientsUsingProfile: null,
                clientListUsingProfile: [],

                // b-table properties
                perPageOptions: [5, 10, 50, 100],
                currentPage: 1,
                perPage: 5,
                filter: null,
                noSearchResultRows: null,
                totalRows: null
            }
        },
        computed: {
            rows() {
                return this.totalRows;
            }
        },
        methods: {
            //On toggle(ON/OFF) profile core functions
            onToggle(event) {
                this.coreFunctionList.forEach(el => {
                    if (event.profileFunction.id === el.id) {
                        el.active = event.value ? 1 : 0;
                    }
                });
    
                this.memberProfileSetting.functionIds = this.coreFunctionList.filter(el => el.active).map(func => func.id);
            },
            //Initialize data on load
            async init() {
                try {
                    this.showLoader = true;
                    await this.getCoreFunctions();
                    await this.fetchMemberProfileList();
                } catch (e) {
                    this.$toasted.error(e);
                } finally {
                    this.showLoader = false;
                }
            },
            //Get core functions
            async getCoreFunctions() {
                try {
                    // HTTP call for get core function list
                    const endpoint = memberProfile.getFunction('core');
                    const fetchFunctionResponse = await this.$api.get(endpoint);
                    if (!fetchFunctionResponse.data.success) {
                        throw fetchFunctionResponse.data.error;
                    }
                    
                    let { data } = fetchFunctionResponse.data;
                    this.coreFunctionList = data;
                    this.coreFunctionList.forEach(el => el.active = el.by_default_selected ? 1 : 0);
                    this.memberProfileSetting.functionIds = this.coreFunctionList.filter(el => el.active).map(func => func.id);
                } catch (e) {
                    const errorMesage = e ? e : 'Failed to get tablet functions !';
                    this.$toasted.error(errorMesage);
                }
            },
            //Fetch member profile list
            async fetchMemberProfileList() {
                try {
                    // HTTP call for fetch member profile list
                    const endpoint = memberProfile.getMemberProfileList();
                    const fetchMemberProfilesResponse = await this.$api.get(endpoint);
                    if (!fetchMemberProfilesResponse.data.success) {
                        throw fetchMemberProfilesResponse.data.error;
                    }
                    let { data } = fetchMemberProfilesResponse.data;
                    this.memberProfileHistoryList = data.map(el => {
                        if (el.created_at) {
                            el.created_at = dayjs(el.created_at).format('MM/DD/YYYY, hh:mm A');
                        }

                        if (el.updated_at) {
                            el.updated_at = dayjs(el.updated_at).format('MM/DD/YYYY, hh:mm A');
                        }
                        return el;
                    });
                    this.totalRows = this.memberProfileHistoryList.length;
                } catch (e) {
                    const errorMessage = e ? e : 'Failed to fetch member profiles !';
                    this.$toasted.error(errorMessage);
                }
            },
            //Save Profile setting
            async saveProfileSetting() {
                try {
                    const form = this.$refs.form;
                    const isFormValid = await form.validate();
                    if (!isFormValid) {
                        this.$toasted.error('Please fill all required fields');
                        return;
                    }
                    this.showLoader = true;

                    // HTTP call for get core function list
                    const endpoint = memberProfile.createMemberProfile();
                    const saveProfileSettingResponse = await this.$api.post(endpoint, this.memberProfileSetting);
                    if (!saveProfileSettingResponse.data.success) {
                        throw saveProfileSettingResponse.data.error;
                    }

                    this.$toasted.success('Profile settings saved successfully');
                    this.resetForm();
                } catch (e) {
                    const errorMessage = e ? e : 'Failed to save profile settings !';
                    this.$toasted.error(errorMessage);
                } finally {
                    this.showLoader = false;
                }
            },
            //Update profile setting
            async updateProfile() {
                try {
                    const form = this.$refs.form;
                    const isFormValid = await form.validate();
                    if (!isFormValid) {
                        this.$toasted.error('Please fill all required fields');
                        return;
                    }
                    this.showLoader = true;
                    
                    // HTTP call for get core function list
                    const endpoint = memberProfile.updateMemberProfile(this.selectedProfileRowId);
                    const updateProfileSettingResponse = await this.$api.put(endpoint, this.memberProfileSetting);
                    if (!updateProfileSettingResponse.data.success) {
                        throw updateProfileSettingResponse.data.error;
                    }

                    this.$toasted.success('Profile settings updated successfully');
                    this.cancelEdit();
                } catch (e) {
                    const errorMessage = e ? e : 'Failed to update profile settings !';
                    this.$toasted.error(errorMessage);
                } finally {
                    this.showLoader = false;
                }
            },
            //Edit profile
            async editProfile(row) {
                try {
                    this.showLoader = true;

                    this.selectedProfileRowId = row.item.id;
                    await this.getCoreFunctions();

                    // HTTP call for get member profile detail
                    const endpoint = memberProfile.getMemberProfileDetail(row.item.id);
                    const memberProfileDetailResponse = await this.$api.get(endpoint);
                    if (!memberProfileDetailResponse.data.success) {
                        throw memberProfileDetailResponse.data.error;
                    }

                    let { data } = memberProfileDetailResponse.data;
                    this.memberProfileSetting = {
                        profileName: data.profile_name,
                        ageGroup: data.age_group,
                        functionIds: []
                    };

                    // Making all field active status to 0
                    this.coreFunctionList.forEach(coreFunc => coreFunc.active = 0);
                    data.functions.forEach(func => {
                        let foundFunc = this.coreFunctionList.find(coreFunc => coreFunc.id === func.function_id);
                        if (foundFunc) {
                            this.coreFunctionList.forEach(coreFunc => {
                                if (coreFunc.id === foundFunc.id) {
                                    coreFunc.active = 1;
                                }
                            });
                        } else {
                            func['id'] = func.function_id;
                            this.coreFunctionList.push(func);
                        }
                    });
            
                    this.memberProfileSetting.functionIds = this.coreFunctionList.filter(el => el.active).map(func => func.id);
                    this.showSaveSetting = false;
                    // Scroll up to top
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    });
                } catch (e) {
                    const errorMessage = e ? e : 'Failed to get profile detail !';
                    this.$toasted.error(errorMessage);
                } finally {
                    this.showLoader = false;
                }
            },
            deleteProfile(memberProfile) {
                this.memberProfileToDelete = { memberProfileId: memberProfile?.item?.id, index: memberProfile.index};
                if( !this.memberProfileToDelete ) {
                    this.$toasted.error( `Member profile id not found !` );
                    return;
                }
                
                this.clientListUsingProfile = memberProfile?.item?.clientListUsingProfile;
                this.showDeleteAlert = true;
            },
            async handleDelete() {
                try {
                    this.showDeleteAlert = false;
                    this.showLoader = true;

                    // HTTP call for delete member profile
                    const endpoint = memberProfile.deleteMemberProfile( this.memberProfileToDelete.memberProfileId );
                    const deleteMemberProfileSettingResponse = await this.$api.delete(endpoint);
                    if (!deleteMemberProfileSettingResponse.data.success) {
                        this.clientListUsingProfile = deleteMemberProfileSettingResponse.data.data;
                        this.showDeleteAlert = true;
                        return;
                    }

                    this.fetchMemberProfileList();
                    this.$toasted.success('Member Profile Deleted successfully !');

                } catch (e) {
                    const errorMessage = e ? e : 'Failed to delete member profile !';
                    this.$toasted.error(errorMessage);
                } finally {
                    this.showLoader = false;
                }
            },
            // On click on member name link in delete profile alert modal
            onClickMemberName(clientId) {
                if (!clientId) {
                    this.$toasted.error('Member id not found!');
                    return;
                }

                this.showDeleteAlert = false;
                const clientDemographicsPage = {
                    label: "ClientDemographics",
                    name: "ClientDemographics", "params": { "client_id": clientId }
                }
                this.$router.push(clientDemographicsPage);
            },
            //ON save third party functions
            onSaveThirdPartyApplication(selectedThirdPartyApplications) {    
                selectedThirdPartyApplications.forEach(thirdPartyFunc => {
                    let isThirdPartyFuncExist = this.coreFunctionList.find(coreFunc => coreFunc.id === thirdPartyFunc.id);
                    if (!isThirdPartyFuncExist && thirdPartyFunc.active) {
                        this.coreFunctionList.push(thirdPartyFunc);
                    } else if(isThirdPartyFuncExist && !thirdPartyFunc.active) {
                        this.coreFunctionList = this.coreFunctionList.filter(coreFunc => coreFunc.id !== isThirdPartyFuncExist.id);
                    }
                });
          
                this.memberProfileSetting.functionIds = this.coreFunctionList.filter(el => el.active).map(func => func.id);
            },
            onDeleteThirdParty(thirdPartyFunctionId) {
                this.openLauncherModal = false;
                this.showThirdPartyDeleteAlert = true;
                this.thirdPartyFunctionIdToDelete = thirdPartyFunctionId;
            },
            async handleThirdPartyDelete() {
                try {
                    this.showThirdPartyDeleteAlert = false;
                    this.showLoader = true;

                    // HTTP call for delete third party application
                    const endpoint = memberProfile.deleteFunction(this.thirdPartyFunctionIdToDelete);
                    const deleteThirdPartyAppResponse = await this.$api.delete(endpoint);
                    if (!deleteThirdPartyAppResponse.data.success) {
                        throw deleteThirdPartyAppResponse.data.Message;
                    }
        
                    this.$toasted.success('Application Deleted successfully !');

                } catch (e) {
                    const errorMessage = e ? e : 'Failed to delete application !';
                    this.$toasted.error(errorMessage);
                } finally {
                    this.showLoader = false;
                    this.openLauncherModal = true;
                }
            },
            //Filter row items on search
            onFiltered(filteredItems) {
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.noSearchResultRows = null;
                this.totalRows = filteredItems.length;
                this.noSearchResultRows = filteredItems.length;
                this.currentPage = 1;
            },
            changeCountPerPage({ target: { value } }) {
                this.perPage = Number(value);
            },
            close() {
                this.openLauncherModal = false;
            },
            cancelEdit() {
                this.showSaveSetting = true;
                this.resetForm();
            },
            //Reset form
            resetForm() {
                this.memberProfileSetting = {
                    profileName: '',
                    ageGroup: 'adult',
                    functionIds: []
                }
                requestAnimationFrame(() => {
                    this.$refs.form.reset();
                });
                this.init();
            }
        },
        created() {
            this.init();
        }
    }
</script>